var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { WidgetGroup, QueryChangeAction, ExprTag, QueryChangePart, SortDirection } from '@easyquery/core';
import { utils as dataUtils } from '@easydata/core';
import { EasyGrid } from '@easydata/ui';
import { Grid } from './grid';
import { PopupMenu } from '../utils/popup_menu';
var EasyGridWidget = /** @class */ (function (_super) {
    __extends(EasyGridWidget, _super);
    /**
     * The default constructor.
     * @param slot The html element.
     */
    function EasyGridWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.hasCustomTotalsSettings = false;
        //!!!! DO NOT forget to add types for options
        _this.options = { autoRefresh: true };
        _this.group = WidgetGroup.Result;
        return _this;
    }
    EasyGridWidget.prototype.getWidgetType = function () {
        return 'easyGrid';
    };
    /**
     * Initialize widget.
     * @param context The context.
     * @param options The options.
     */
    EasyGridWidget.prototype.init = function (context, options) {
        var _this = this;
        _super.prototype.init.call(this, context, options);
        var gridOptions = __assign(__assign({}, options), { slot: this.slot, dataTable: context.resultTable });
        this.options = dataUtils.assign(this.options, options);
        gridOptions.onPlusButtonClick = function (ev) { return _this.addColumnClickHandler(ev); };
        gridOptions.onColumnMoved = function (ev) { return _this.columnMovedHandler(ev); };
        if (gridOptions.aggregates) {
            this.hasCustomTotalsSettings = true;
        }
        else {
            gridOptions.aggregates = { settings: context.getQuery().getAggregationSettings(), calculator: null };
        }
        gridOptions.aggregates.calculator = this.context.getServices()
            .getAggregatesCalculator();
        this.destroy();
        this.grid = new EasyGrid(gridOptions);
        if (this.options.autoRefresh) {
            this.attachQueryObserver();
        }
    };
    EasyGridWidget.prototype.refreshCore = function () {
        this.clear();
        this.updateTotalsSettings();
        this.render();
    };
    EasyGridWidget.prototype.render = function () {
        this.createEntitiesMenu();
        this.grid.refresh();
    };
    EasyGridWidget.prototype.attachQueryObserver = function () {
    };
    EasyGridWidget.prototype.destroyCore = function () {
        this.detachQueryObserver();
        if (this.grid)
            this.grid.destroy();
        this.slot.innerHTML = '';
    };
    EasyGridWidget.prototype.detachQueryObserver = function () {
        if (this.queryEventCallbackId) {
            var query = this.getContext().getQuery();
            query.removeChangedCallback(this.queryEventCallbackId);
        }
    };
    EasyGridWidget.prototype.updateTotalsSettings = function () {
        var context = this.getContext();
        if (!this.hasCustomTotalsSettings) {
            var settings = context.getQuery().getAggregationSettings();
            this.grid.options.aggregates.settings = settings;
        }
    };
    EasyGridWidget.prototype.createEntitiesMenu = function () {
        var model = this.getContext().getModel();
        if (!model || model.isEmpty())
            return;
        var menuId = this.slot.id;
        if (menuId) {
            menuId += '-EntitiesMenu';
        }
        var entitiesList = model.getEntitiesTree({ addUIC: false, addUIR: true, addUIS: false });
        var options = { items: entitiesList, id: menuId };
        dataUtils.assign(options, this.options.menuOptions);
        this.entitiesMenu = new PopupMenu(options);
    };
    EasyGridWidget.prototype.getModel = function () {
        return this.context.getModel();
    };
    EasyGridWidget.prototype.getQuery = function () {
        return this.context.getQuery();
    };
    EasyGridWidget.prototype.clear = function () {
        if (this.grid)
            this.grid.clear();
    };
    EasyGridWidget.prototype.addColumnClickHandler = function (ev) {
        var _this = this;
        this.entitiesMenu.showMenu({
            anchor: ev.sourceEvent.target,
            selectedIds: null,
            itemSelectedCallback: function (data, items) {
                var attrid = data.id;
                _this.addNewColumn(attrid);
                return false;
            }
        });
    };
    EasyGridWidget.prototype.columnMovedHandler = function (ev) {
        var query = this.getQuery();
        var oldIndex = dataUtils.findItemIndexById(query.getColumns(), ev.columnId);
        if (oldIndex >= 0) {
            query.moveColumn(oldIndex, ev.newIndex);
            query.fireChangedEvent({
                part: QueryChangePart.Columns,
                action: QueryChangeAction.All,
                source: this
            });
        }
    };
    EasyGridWidget.prototype.addNewColumn = function (attrId) {
        var _this = this;
        var model = this.getContext().getModel();
        var query = this.getContext().getQuery();
        var getColumnByAttrId = function (attrid) {
            var attribute = model.getAttributeById(attrid);
            if (!attribute) {
                return null;
            }
            if (!attribute.useInSorting) {
                if (attribute.lookupAttr) {
                    attrid = attribute.lookupAttr;
                    attribute = model.getAttributeById(attrid);
                    if (!attribute || !attribute.useInSorting) {
                        return null;
                    }
                }
                else
                    return null;
            }
            var column = query.createColumn();
            column.caption = _this.getDefaultColumnCaption(attribute);
            column.sorting = SortDirection.None;
            column.sortIndex = -1;
            column.expr.tag = ExprTag.EntityAttribute;
            //column.expr.id = attrid;
            column.expr.setValue(attrid, true);
            column.params.concat(attribute.params);
            return column;
        };
        if (!this.getContext().getQuery()) {
            return;
        }
        return this.addColumn(getColumnByAttrId(attrId));
    };
    EasyGridWidget.prototype.getDefaultColumnCaption = function (attr) {
        var format = this.options.titleElementFormat || this.options.attrElementFormat;
        var model = this.getContext().getModel();
        return model.getAttributeText(attr, format);
    };
    EasyGridWidget.prototype.addColumn = function (column) {
        var query = this.getContext().getQuery();
        if (!query) {
            return;
        }
        column = this.checkColumn(column);
        if (!column) {
            return;
        }
        column = query.addColumn({
            caption: column.caption,
            attributeId: column.expr.value,
            sorting: column.sorting,
            sortIndex: column.sortIndex
        });
        query.fireChangedEvent({
            part: QueryChangePart.Columns,
            action: QueryChangeAction.Add,
            changee: column,
            source: this
        });
        return column;
    };
    EasyGridWidget.prototype.checkColumn = function (col) {
        var query = this.getContext().getQuery();
        var columns = query.getColumns();
        var colJson = JSON.stringify(col.expr.saveToData());
        for (var i = 0; i < columns.length; i++) {
            var qcolJson = JSON.stringify(columns[i].expr.saveToData());
            if (qcolJson === colJson) {
                return null;
            }
        }
        return col;
    };
    return EasyGridWidget;
}(Grid));
export { EasyGridWidget };
//# sourceMappingURL=easy_grid_widget.js.map